import * as React from 'react';
import { Checkbox, Divider } from '@mui/material';
import { InfoListItem } from '@brightlayer-ui/react-components/core';
import { useDispatch, useSelector } from 'react-redux';
//import { isTrendlineEnabled } from '../../state/dashboard-state';
import { ChartColors, ChartColorsBackground, ChartColorsHover } from '../ReusableTrendsGraph/colors';
import { Selectors } from '../../selectors';
import { Actions } from '../../actions';
import { AppRoute } from '../../routes';

export const DeviceTrendChannelList: React.FC<{
    trends: Array<{
        id: number;
        channelName: string;
        deviceId: string;
        deviceName: string;
        value: Array<{
            dateTime: string;
            value: string;
        }>;
        unit: string | null;
        category?: string;
    }>;
    viewTrendviewerAppRoute?: AppRoute;
    selectedChannel: Function;
}> = (props) => {
    const dispatch = useDispatch();
    // const trendLinesEnabled = useSelector(Selectors.Dashboard.trendLinesEnabled);
    const hoveredTrendline = useSelector(Selectors.Dashboard.hoveredTrendline);
    const [channelList, setChannelList] = React.useState<any[] | null>(null);
    const convertHex = (hex: string, opacity: number): string => {
        const newhex = hex.replace('#', '');
        const r = parseInt(newhex.substring(0, 2), 16);
        const g = parseInt(newhex.substring(2, 4), 16);
        const b = parseInt(newhex.substring(4, 6), 16);

        return `rgba(${r},${g},${b},${opacity / 100})`;
    };

    React.useEffect(() => {
        const selectedChannels: Array<{ id: string; name: string }> = [];
        props.trends.map((trendData) =>
            selectedChannels.push({ id: trendData.id.toString(), name: trendData.channelName })
        );
        const list = props.trends.map((elem: any, index: number) => ({
            ...elem,
            checked: index < 1 ? true : false,
            color: ChartColors[index % ChartColors.length],
        }));
        setChannelList(list);

        const selectedChannelsFilter = list
            .filter((x) => x.checked === true)
            .map((x) => ({ id: x.id, channelName: x.channelName, deviceId: x.deviceId }));

        dispatch(Actions.TrendChannels.trendChannelsSelected(selectedChannelsFilter));
        dispatch(Actions.Dashboard.trendListItemCheckboxClear());
    }, [props.trends, dispatch]);

    const onClick = (channel: any): void => {
        if (channelList === null) return;
        const channels = channelList.map((x) =>
            x.id === channel.id && x.deviceId === channel.deviceId ? { ...x, checked: !channel.checked } : x
        );

        const checkedChannel = channels.filter((x) => x.checked === true);

        if (checkedChannel && checkedChannel.length <= 10) {
            // console.log('checkedChannel', checkedChannel);
            const selectedChannelsFilter = checkedChannel
                .filter((x) => x.checked === true)
                .map((x) => ({ id: x.id, channelName: x.channelName, deviceId: x.deviceId }));
            dispatch(Actions.TrendChannels.trendChannelsSelected(selectedChannelsFilter));
            dispatch(Actions.Dashboard.trendListItemCheckboxClicked(channel.id, channel.deviceId));
            setChannelList(channels);
            props.selectedChannel(checkedChannel);
        }
    };

    return (
        <>
            <Divider />
            {channelList &&
                channelList.map((trendDatum, index) => (
                    <div
                        data-testid={`trend-list-item-${index}`}
                        key={index}
                        onMouseEnter={(): void => {
                            dispatch(Actions.Dashboard.trendListItemEntered(trendDatum.id, trendDatum.deviceId));
                        }}
                        onMouseLeave={(): void => {
                            dispatch(Actions.Dashboard.trendListItemLeft());
                        }}
                    >
                        <InfoListItem
                            title={trendDatum.channelName}
                            subtitle={trendDatum.category}
                            data-testid={trendDatum.channelName}
                            backgroundColor={
                                hoveredTrendline &&
                                trendDatum.id === hoveredTrendline.channelId &&
                                trendDatum.deviceId === hoveredTrendline.deviceId
                                    ? convertHex(ChartColorsHover[index % ChartColorsHover.length], 5)
                                    : convertHex(ChartColorsBackground[index % ChartColorsBackground.length], 3)
                            }
                            icon={
                                <Checkbox
                                    data-testid="trend-item-checkbox"
                                    checked={trendDatum.checked}
                                    style={{ color: ChartColors[index % ChartColors.length] }}
                                />
                            }
                            statusColor={ChartColors[index % ChartColors.length]}
                            divider={'full'}
                            onClick={(): void => {
                                onClick(trendDatum);
                            }}
                        />
                    </div>
                ))}
        </>
    );
};
